<div class="bottom-sheet">
  <div class="data">
      The Node Displayed in the PSNB/Continuity does not match the Node in the NCP <br>
      1. Query MAC Address in Scout using the NCP Node Lookup under the Device Watch Menu<br>
      2. Capture the correct node<br>
      3. Move Power Supply to its correct node
 </div>
  <button mat-button type="button" color="warn" (click)="clearBar()">Cancel</button>
</div>
